import { gql } from "@apollo/client";

export const SELLER_PRODUCTS_QUERY = gql`
  query SellerProducts($page: Int!, $pageSize: Int!, $filter: ProductFilterInputt) {
    sellerProducts(page: $page, page_size: $pageSize, filter: $filter) {
      products {
        entityid
        name
        sku
        seller_reference
        image1 {
          url
          label
        }
        stock_data {
          qty
          is_in_stock
        }
        }
      pagination {
        total_count
        current_page
        total_pages
      }
    }
  }
`;
